import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

//Component
import {Provider} from 'react-redux';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {rootReducer} from './reducers';
import thunk from 'redux-thunk';
import {applyMiddleware, compose, createStore} from 'redux';
import 'react-toastify/dist/ReactToastify.css';

class Root extends React.Component {
    render() {
        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <Switch>
                        <Route path="/" component={App}/>
                    </Switch>
                </BrowserRouter>
            </Provider>
        );
    }
}

ReactDOM.render(<Root/>, document.getElementById('root'));

serviceWorker.unregister();
